import BaseSyncError from "scripts/exceptions/baseSyncError";

class InternalServerSyncError extends BaseSyncError {}

export default InternalServerSyncError;
